/* eslint-disable  react/display-name */
import { Button, Grid, IconButton, Tooltip, CircularProgress } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import CloseIcon from "@mui/icons-material/Close";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import API from "../../../utils/API";
import { SyncUtils } from "../../../utils/SyncUtils";
import { PricingUtils } from "../../../utils/PricingUtils";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function StockTransferCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [description, setDescription] = useState(null);
  const [descriptionError, setDescriptionError] = useState(null);

  const [openWindow, setOpenWindow] = useState(false);
  const [mode, setMode] = useState("create");
  const [items, setItems] = useState([]);
  const [prodLookupValue, setProdLookupValue] = useState();
  const [openFileDropWindow, setOpenFileDropWindow] = useState(false);
  const [targetShop, setTargetShop] = useState(null);
  const [targetShopError, setTargetShopError] = useState();

  const [shops, setShops] = useState([]);
  const [isSaveLoaderEnabled, setIsSaveLoaderEnabled] = useState(false);
  const [saveLabel, setSaveLabel] = useState("POST");
  const [origObject, setOrigObject] = useState(null);

  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  const REST_API_PAYLOAD_LIMIT = 5; //Maximum rows to send in single request

  useEffect(() => {
    if (props.context.store.branches) {
      let d = [];
      for (let b of props.context.store.branches) {
        console.log(">>>", b, props.context.store.code);
        if (b.code != props.context.store.code) {
          d.push({
            name: b.code,
            code: b.code,
          });
        }
      }
      setShops(d);
    }
  }, []);

  props.biRef.outgoing = {
    showWindow: showWindow,
  };

  async function showWindow(origBeanId) {
    if (origBeanId) {
      populateOrigBean(origBeanId);
    } else {
      refreshScreen();
    }

    setSaveLabel("POST");
    setOpenWindow(true);
  }

  function refreshScreen() {
    setMode("create");
    setOrigObject(null);
    loadRecordsFromCache(true);
    setDescriptionError(null);
    setDescription("");
    setOrigObject(null);
    setIsSaveLoaderEnabled(false);
    setTargetShop(null);
  }

  async function populateOrigBean(origBeanId) {
    try {
      let { data } = await API.get(
        "/api/v1/inventory/transfer/outgoing/" + origBeanId
      );
      setMode("edit");
      populateData(data);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate("Not able to retrive inventroy adjustment data from server")
      );
    }
  }

  async function populateData(bean) {
    setOrigObject(bean);
    setDescription(bean.description);
    setTargetShop({ name: bean.targetShopCode, code: bean.targetShopCode });
    let sn = 1;
    let l = [];
    bean.itemList.map((v) => {
      let row = [
        { v: sn },
        { v: v.productName },
        { v: v.price },
        { v: v.qty },
        { v: v.amount },
        {
          info: {
            productBean: v.productBean,
            pricingBean: v.pricingBean,
          },
        },
      ];
      l.push(row);
      sn = sn + 1;
    });
    setItems(l);
  }

  async function loadRecordsFromCache(isClearListEnable) {
    let inventoryAdjBulkImportDb = await db.inventoryAdjBulkImport.toArray();
    let updatedTableRows = [];
    if (inventoryAdjBulkImportDb.length > 0) {
      let sn = 1;
      for (let rowItem of inventoryAdjBulkImportDb) {
        //rowItem.payload[5].v = "PENDING";
        rowItem.payload[0].v = sn;
        updatedTableRows.push(rowItem.payload);
        sn++;
      }
      setItems(updatedTableRows);
    } else if (isClearListEnable) {
      setItems([]);
    }
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }
  function onDelete() { }
  async function onSave() {
    if (validate()) {
      setConfirmOpen(true);
      setConfirmContext({
        title: translate("Are You Sure"),
        message: translate(
          "Are you sure to proceed, This action can not be undone!"
        ),
        type: "warning",
        open: true,
        yes: true,
        no: true,
      });
    }
  }

  async function handleSaveDraftClicked() {
    if (validate()) {
      saveData("DRAFT");
    }
  }

  function validate() {
    let rValue = true;
    if (!description || description === "") {
      props.showMessage("error", translate("Validation failed"));
      setDescriptionError(translate("Description is required"));
      rValue = false;
    }
    if (!targetShop || targetShop === "") {
      props.showMessage("error", translate("Validation failed"));
      setTargetShopError(translate("Target Shop is required"));
      rValue = false;
    }
    if (items.length < 1) {
      props.showMessage(
        "error",
        translate("Please add products before proceed")
      );
      rValue = false;
    }
    //for (let i = 0; i < items.length; i++) {}
    return rValue;
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function saveData(status) {
    if (validate()) {
      var payload = createPayload(status);
      try {
        showProgress(true, "Saving");
        let { data } = await API.post(
          "/api/v1/inventory/transfer/outgoing",
          payload
        );
        setOrigObject(data);
        setMode("edit");

        props.showMessage("success", translate("Saved Successfully"));
        props.refreshList();
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        props.showMessage(
          "error",
          translate("Not able to Save Stock Transfer")
        );
      }
    }
  }

  function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      setIsSaveLoaderEnabled(true);
      saveData("POSTED");
      setIsSaveLoaderEnabled(false);
    }
  }

  function createPayload(status) {
    let saveObject = Object.create(null);
    console.log(mode);
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
      saveObject["orderId"] = "AUTO";
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
      saveObject["orderId"] = origObject.orderId;
      saveObject["financialYearId"] = origObject.financialYearId;
      saveObject["fromShop"] = origObject.fromShop;
      saveObject["targetShopCode"] = origObject.targetShopCode;
    }

    saveObject["description"] = description;
    if (props.stockTransferType == "OUT") {
      saveObject["targetShopCode"] = targetShop.code;
    }

    saveObject["status"] = status;
    saveObject["transferType"] = props.stockTransferType;
    let itemsToSave = [];
    let totalAmount = 0;
    items.map((value) => {
      console.log(value);
      let itemsObject = Object.create(null);
      itemsObject["productId"] = value[5].info.productBean.id;
      itemsObject["pricingId"] = value[5].info.pricingBean.unitType;
      itemsObject["productName"] = value[5].info.productBean.name;
      itemsObject["price"] = value[2].v;
      itemsObject["qty"] = value[3].v;
      itemsObject["amount"] = value[4].v;
      itemsObject["productBean"] = value[5].info.productBean;
      itemsObject["pricingBean"] = value[5].info.pricingBean;
      //itemsObject["status"] = value[5].v;
      itemsToSave.push(itemsObject);
      totalAmount = totalAmount + parseFloat(itemsObject["amount"]);
    });
    saveObject["totalAmount"] = totalAmount;

    saveObject["itemList"] = itemsToSave;
    return saveObject;
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.unitType}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.price}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };
  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  function getItemIndex(productId, itemList) {
    let index = null;
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i][5].info.productBean.id == productId) {
        index = i;
        break;
      }
    }
    return index;
  }
  async function addProductToTable(productBean, pricingBean) {
    var data = [...items];
    let itemIndex = getItemIndex(productBean.id, data);
    if (itemIndex == null) {
      console.log(productBean, pricingBean);
      let sn = data.length + 1;
      let item = [
        { v: sn },
        { v: productBean.name },
        { v: pricingBean.cost },
        { v: 1 },
        { v: pricingBean.cost }, //Stock change Reason
        {
          info: {
            productBean: productBean,
            pricingBean: pricingBean,
            barcode: null,
          },
        },
      ];
      data.push(item);
      setItems(data);
    } else {
      props.showMessage("warning", translate("Product alredy exists"));
    }
  }

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let data = [...tableMeta.tableData];
    let barcodeToRemove = data[tableMeta.rowIndex][5].info.barcode;
    data.splice(tableMeta.rowIndex, 1);
    if (tableMeta.rowIndex != tableMeta.tableData.length - 1) {
      for (let i = tableMeta.rowIndex; i < data.length; i++) {
        data[i][0].v = data[i][0].v - 1;
      }
    }
    setItems(data);
    if (barcodeToRemove != null)
      db.table("inventoryAdjBulkImport").delete(barcodeToRemove);
  }

  async function getOptionsAsync(inputValue, callback) {
    let arr = await SyncUtils.searchInCache(
      props.productCache,
      inputValue,
      100
    );
    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );
    //return callback([]);
  }

  const productLookupChanged = (newValue) => {
    prodSelected(newValue);
  };

  async function prodSelected(newValue) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(
      newValue.value
    );
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modifed, please Reload the Window");
    } else {
      addProductToTable(prodBean, pricingBean);
    }
    setProdLookupValue({ label: null, value: null });
  }

  function updateData(eventSource, meta, value, index) {
    if (eventSource === "qty") {
      var data = [...items];
      data[meta.rowIndex][meta.columnIndex] = value;
      if (value.v == "") {
        data[meta.rowIndex][4] = { v: "" };
      } else {
        console.log(
          value.v,
          data[meta.rowIndex][2].v,
          parseFloat(value.v) * parseFloat(data[meta.rowIndex][2].v)
        );
        data[meta.rowIndex][4] = {
          v: PricingUtils.formattedNumber(
            parseFloat(value.v) * parseFloat(data[meta.rowIndex][2].v),
            props.context.store.currencyDecimal
          ),
        };
      }
      console.log(value, data[meta.rowIndex]);
      setItems(data);
    } else if (eventSource === "price") {
      var data = [...items];
      data[meta.rowIndex][meta.columnIndex] = value;
      if (value.v == "") {
        data[meta.rowIndex][4] = { v: "" };
      } else {
        console.log(
          value.v,
          data[meta.rowIndex][3].v,
          parseFloat(value.v) * parseFloat(data[meta.rowIndex][3].v)
        );
        data[meta.rowIndex][4] = {
          v: PricingUtils.formattedNumber(
            parseFloat(value.v) * parseFloat(data[meta.rowIndex][3].v),
            props.context.store.currencyDecimal
          ),
        };
      }
      console.log(value, data[meta.rowIndex]);
      setItems(data);
    }
  }

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productName",
      label: translate("Product Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 260 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "price",
      label: translate("Rate"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 80 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "price",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={
                props.stockTransferType == "IN" ? { readOnly: true } : {}
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "qty",
      label: translate("Quantity"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 80 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "qty",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={
                props.stockTransferType == "IN" ? { readOnly: true } : {}
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "amount",
      label: translate("Amount"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 20 }}>{value.v}</div>
        ),
      },
    },
  ];

  if (props.stockTransferType == "OUT") {
    columns.push({
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: props.viewMode == "view" ? "false" : "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "left" }}>
            <Tooltip title={translate("Remove ")}>
              <IconButton
                color="secondary"
                onClick={() =>
                  onRemoveItemClicked(tableMeta, updateValue, value)
                }
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    });
  }

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: getWindowDimensions().height - 400,
    rowsPerPage: Math.round((getWindowDimensions().height - 400) / 50),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 400) / 50),
      15,
      50,
      100,
    ],
  };

  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            {props.stockTransferType == "OUT" && (
              <tr>
                <td width="25%">{translate("Target Shop")}</td>
                <td>
                  <PSelect
                    options={shops}
                    value={targetShop}
                    onChange={(event, newValue) => {
                      setTargetShop(newValue);
                      setTargetShopError("");
                    }}
                    errorMessage={targetShopError}
                  ></PSelect>
                </td>
              </tr>
            )}
            {props.stockTransferType == "IN" && (
              <tr>
                <td width="25%">{translate("From Shop")}</td>
                <td>
                  <PText
                    value={origObject ? origObject.fromShop : ""}
                    InputProps={{ readOnly: true }}
                  ></PText>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td width="15%">{translate("Description")}</td>
              <td>
                <PText
                  value={description}
                  error={descriptionError}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setDescriptionError(null);
                  }}
                ></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      {props.stockTransferType === "OUT" && (
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tr>
              <td width="88%">
                <AsyncSelect
                  formatOptionLabel={formatOptionLabel}
                  components={{ formatOptionLabel }}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    marginRight: "10px",
                  }}
                  placeholder={translate("Product Lookup")}
                  loadOptions={getOptions}
                  onChange={productLookupChanged}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                  value={prodLookupValue}
                />
              </td>

              <td width="2%">
                {props.stockTransferType === "OUT" && (
                  <Tooltip title={translate("Clear Cache")}>
                    <IconButton
                      color="secondary"
                      onClick={() => {
                        db.table("inventoryAdjBulkImport").clear();
                        setItems([]);
                      }}
                    >
                      <CachedIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </td>
            </tr>
          </table>
        </Grid>
      )}
      <Grid item xs={12} sm={12}>
        <MUIDataTable data={items} columns={columns} options={options} />
      </Grid>
    </Grid>
  );
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={
            props.stockTransferType == "OUT"
              ? translate("Send Stock")
              : translate("Receive Stock")
          }
          maxWidth={"lg"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          saveLabel={saveLabel}
          isSaveLoaderEnabled={isSaveLoaderEnabled}
          saveDisabled={isSaveLoaderEnabled}
          //onDelete={onDelete}
          mode={mode}
          hideSave={origObject && origObject.status === "POSTED"}
          showSaveDraftButton={
            props.stockTransferType == "OUT" &&
            !(origObject && origObject.status === "POSTED")
          }
          onSaveDraftClicked={handleSaveDraftClicked}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
